<template lang="pug">
.container
  // h1(v-if="error.statusCode === 404")
  // h1(v-else) 应用发生错误异常
  fq-ignore
  nuxt-link(to="/")
    //- rr-button.gohome-btn(text='返回首页')
</template>

<script>
export default {
  props: ['error'],
  layout: 'default' // 你可以为错误页面指定自定义的布局
}
</script>
<style scoped lang='sass'>
.container
  text-align: center
.gohome-btn
  width: 180px
  height: 45px
  margin: 0 auto
</style>
